import React from 'react';
import onClickOutside from 'react-onclickoutside';

import { trans } from '../../../../localization';

class UserDropdown extends React.PureComponent {
  handleClickOutside = () => {
    const { toggleUserOpen } = this.props;
    toggleUserOpen(false);
  };
  render() {
    const { onLogoutClick, openSettingModal } = this.props;
    return (
      <div className="dropdown-menu show">
        <span onClick={() => openSettingModal(true)}>
          <div className="row">
            <div className="col">{trans('set_setting')}</div>
            <div className="col-auto">
              <i className="fas fa-cogs" />
            </div>
          </div>
        </span>
        <span onClick={onLogoutClick}>
          <div className="row">
            <div className="col">{trans('logout')}</div>
            <div className="col-auto">
              <i className="fas fa-sign-out-alt" />
            </div>
          </div>
        </span>
      </div>
    );
  }
}

export default onClickOutside(UserDropdown);



// WEBPACK FOOTER //
// ./foody/src/layout/components/Header/components/UserDropdown.jsx